import { apiClient } from './apiClient';

export interface BusinessPosition {
  id: number;
  name: string;
}

/**
 * Business Position API Service
 * Handles business position operations
 */
export class BusinessPositionService {
  /**
   * Create a new business position
   * 
   * @param name - Name of the position
   * @returns Promise with the created position
   */
  async createPosition(name: string): Promise<BusinessPosition> {
    try {
      const response = await apiClient.post<BusinessPosition>(
        '/business-positions/',
        { name }
      );
      
      return response.data;
    } catch (error: any) {
      throw {
        message: error.message || 'Error al crear cargo',
        originalError: error,
      };
    }
  }
}

/**
 * Singleton instance of BusinessPositionService
 */
export const businessPositionService = new BusinessPositionService();

export default businessPositionService;
